<template>
  <el-form
    ref="formRef"
    :model="form"
    :label-width="labelWidth"
    :label-position="labelPosition"
    :rules="rules"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <el-row>
      <el-col
        v-for="(item, idx) of wrapperList"
        :key="item.label + item.prop + idx"
        v-bind="item.position"
      >
        <el-form-item v-bind="getFormItemAttrs(item)">
          <slot :name="item.prop" v-bind="item">
            <component
              :is="item.render"
              v-model.trim="form[item.prop]"
              v-bind="item.attrs"
              v-on="item.listeners"
            >
          
            <el-button slot="append" v-if="item.attrs.btn" icon="el-icon-search" v-on="item.listeners"></el-button>
          </component>
          </slot>
        </el-form-item>
      </el-col>

      <el-col>
        <slot v-if="$slots.after || btns.length" name="after">
          <template v-for="(btn, idx) of wrapperBtns">
            <el-button
              :key="btn.label + idx"
              :loading="loading"
              v-bind="btn.attrs"
              v-on="btn.listeners"
              >{{ btn.label }}</el-button
            >
          </template>
        </slot>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
const DEFAULT_CONFIG = {
  render: "ElInput",
  get attrs() {
    return {};
  },

  get position() {
    return {
      span: 8,
    };
  },

  get listeners() {
    return {};
  },
};

export default {
  name: "FestivalForm",
  model: { prop: "form" },
  inheritAttrs: false,
  props: {
    form: {
      type: Object,
      default: () => ({}),
      comment: "v-model",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
      comment: "form list",
    },
    btns: {
      type: Array,
      default: () => [],
      comment: "operator buttons",
    },
    rules: {
      type: Object,
      default: () => ({}),
      comment: "form rules",
    },
    disabled: {
      type: Boolean,
      default: false,
      comment: "disabled form",
    },
    labelWidth: {
      type: [String, Number],
      default: "100px",
    },
    labelPosition: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  computed: {
    wrapperList({ list }) {
      return list.reduce((acc, field) => {
        if (field.prop) acc.push(Object.assign({}, DEFAULT_CONFIG, field));
        return acc;
      }, []);
    },
    wrapperBtns({ btns }) {
      return btns.map((btn) => Object.assign({}, DEFAULT_CONFIG.listeners, btn));
    },
  },

  async mounted() {
    await this.$nextTick();
    this.exposeFormMethods();
  },

  methods: {
    exposeFormMethods() {
      const methods = ["validate", "resetFields", "validateField", "clearValidate"];

      const formRef = this.$refs.formRef;

      methods.forEach((method) => {
        this[method] = (...rest) => formRef[method].apply(this, rest);
      });
    },
    // 过滤多余属性 只保留 form-item 该有的属性
    getFormItemAttrs({ attrs, position, listeners, render, ...props }) {
      return { ...props };
    },
  },
};
</script>
